module.exports = __webpack_public_path__ + "static/media/domManagement.a90b680d.svg";